<bl-page-card-container
  data-smartpresentation="container-pagina"
  id="dispersao-urgencia-emergencia"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
>
  <ng-container header>
    <div class="flex align-items-center">
      <ag-views-toolbar [grid]="agGrid" [gridKey]="GRID_KEY" class="mr-2"></ag-views-toolbar>
      <bl-year-select
        class="ml-4 mr-4"
        [value]="anoBase"
        (next)="navYearRight()"
        (prev)="navYearLeft()"
        [minYear]="anoBaseMinimo"
        [maxYear]="anoAtual"
      ></bl-year-select>

      <div class="competencia mr-5">
        <div class="text-sm font-bold">Competência no RPS</div>
        <div>{{ competenciaRps | competencia }}</div>
      </div>

      <button
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="exportExcel()"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
        [disabled]="!rowData?.length"
      >
        <i class="pi pi-file-excel"></i>
      </button>
      <button
        data-smartpresentation="botao-tela-cheia"
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
      >
        <i
          class="pi"
          [ngClass]="{ 'pi-window-maximize': !(fullscreen$ | async), 'pi-window-minimize': (fullscreen$ | async) }"
        >
        </i>
      </button>
    </div>
  </ng-container>

  <div class="flex flex-1">
    <ag-grid-angular
      #agGrid
      data-smartpresentation="ag-grid"
      class="ag-theme-balham w-full"
      [style.height]="gridHeight$ | async"
      [rowData]="rowData"
      [gridOptions]="gridOptions"
    >
    </ag-grid-angular>
  </div>
</bl-page-card-container>
